import * as React from 'react';
import './notFoundPage.module.scss';

type Props = {
    entityType?: string;
};

export class NotFoundPage extends React.Component<Props> {
    render() {
        const { entityType = 'ページ' } = this.props;
        return (
            <div styleName="not-found-page" id="not-found-page">
                <div styleName="message-box">お探しの{entityType}は見つかりませんでした。 URLをご確認ください。</div>
            </div>
        );
    }
}
